import React, { useMemo, useState } from "react";
import { MessageSquareWarning } from "lucide-react";
import { reportPrefill } from "../../../lib/guide";
import GuideBrowser from "../../guide/GuideBrowser";
import ReportDialog from "../tickets/ReportDialog";

/**
 * "Ghid" in the admin (19.10.2026): how the platform works, for the team.
 * What is missing or wrong becomes a ticket in the area "Ghidul platformei",
 * already naming the article.
 */
export default function GuideTab({ index, onTicket }) {
  const [reporting, setReporting] = useState(null);
  const prefill = useMemo(() => (reporting ? reportPrefill(reporting.article) : null), [reporting]);

  const footer = (article) => (
    <div className="mt-8 flex flex-wrap items-center gap-3 rounded-xl bg-[#F5F6F6] px-4 py-3 text-sm text-[#4B5160]">
      <span className="flex-1 min-w-[12rem]">{article ? "Lipsește ceva din articol sau nu mai e așa?" : "Nu găsești ce cauți?"}</span>
      <button type="button" onClick={() => setReporting({ article })}
        className="inline-flex items-center gap-1.5 rounded-full border border-[#965EA7]/40 px-3 py-1.5 text-[#7A4986] hover:bg-[#965EA7]/10"
        data-testid="guide-report">
        <MessageSquareWarning size={14} aria-hidden="true" /> Lipsește ceva sau e greșit?
      </button>
    </div>
  );

  const welcome = (
    <>
      <h1 className="font-display text-2xl font-bold text-[#373A45]">Ghidul platformei</h1>
      <p className="mt-2 text-[15px] leading-relaxed text-[#4B5160]">
        Cum merg lucrurile în platformă, pas cu pas: înscrieri, grupe, portal, emailuri. Caută un cuvânt
        sau alege un articol din listă. Butonul <strong>(?)</strong> de sus, pe paginile care au un articol,
        te aduce direct aici.
      </p>
    </>
  );

  return (
    <>
      <GuideBrowser apiBase="/admin/guide" index={index} footer={footer} welcome={welcome} />
      <ReportDialog open={!!reporting} onClose={() => setReporting(null)} area="ghid" via="report_button"
        prefill={prefill} onCreated={onTicket} />
    </>
  );
}
